import { render, staticRenderFns } from "./MultiLangInput.vue?vue&type=template&id=f975e6e2&scoped=true"
import script from "./MultiLangInput.vue?vue&type=script&lang=js"
export * from "./MultiLangInput.vue?vue&type=script&lang=js"
import style0 from "./MultiLangInput.vue?vue&type=style&index=0&id=f975e6e2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f975e6e2",
  null
  
)

export default component.exports